import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApiFilter, ApiPage } from "@result/rui/utils/api";

import ApiClient from "#/redux/api/ApiClient";
import { getErrorMessage } from "#/utils/APIUtils";

const baseUrl = "/api/sif/drob/statusOdkupDokument";

export const fetchPurchaseDocumentStatusPage = createAsyncThunk(
  "fetchPurchaseDocumentStatusPage",
  async (_, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get(
        `${baseUrl}/page`,
        undefined,
        new ApiPage().page(0).size(100),
        new ApiFilter().or((orGroup) => {
          orGroup.equal("veljaZaKoze", true);
          orGroup.equal("veljaZaOvce", true);
        }),
        null,
        false
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const purchaseDocumentStatusSlice = createSlice({
  name: "purchaseDocumentStatusSlice",
  initialState: {
    list: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPurchaseDocumentStatusPage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload.content;
      })
      .addCase(fetchPurchaseDocumentStatusPage.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchPurchaseDocumentStatusPage.pending, (state, _) => {
        state.isLoading = true;
        state.error = null;
      });
  },
});

export default purchaseDocumentStatusSlice.reducer;
